import { render, staticRenderFns } from "./DetallePrecalculo.vue?vue&type=template&id=b563f1d2&scoped=true"
import script from "./DetallePrecalculo.vue?vue&type=script&lang=js"
export * from "./DetallePrecalculo.vue?vue&type=script&lang=js"
import style0 from "./DetallePrecalculo.vue?vue&type=style&index=0&id=b563f1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b563f1d2",
  null
  
)

export default component.exports